import { useState } from 'react';
import { campaign } from './campaign';
import CampaignSheet from './CampaignSheet';
import '../../styles/Campaign.css';
import '../../styles/CampaignMobile.css';

/**
 * Tira de campaña (HU-016, lámina 03) — solo mobile (<768px, ver
 * CampaignMobile.css). Vive dentro de `.mapa-principal`, superpuesta sobre
 * el mapa igual que `CampaignDock` en desktop; nunca tapa la bottom-nav ni
 * el FAB de reportar (ver el cálculo del offset en el CSS). Sin
 * `configuracion.banner`, no renderiza nada.
 */
const CampaignStory = ({ configuracion }) => {
  const [sheetAbierto, setSheetAbierto] = useState(false);

  if (!configuracion.banner) return null;

  return (
    <>
      <button
        type="button"
        className="cs-tira"
        onClick={() => setSheetAbierto(true)}
        aria-haspopup="dialog"
      >
        <span className="cs-tira-logo">
          {configuracion.logo && <img src={configuracion.logo} alt="" />}
          <span className="cn-anillo-pulso cs-tira-anillo"></span>
        </span>
        <span className="cs-tira-texto">
          <strong>{configuracion.slogan || campaign.headline}</strong>
          <span>{campaign.candidate}</span>
        </span>
        <span className="cs-tira-boton">Ver</span>
      </button>

      {sheetAbierto && <CampaignSheet configuracion={configuracion} onCerrar={() => setSheetAbierto(false)} />}
    </>
  );
};

export default CampaignStory;
